import { createFileRoute } from "@tanstack/react-router";
import { renderCalibrationTexture } from "gfx/materials/discretization/calibrationTexture";
import { useEffect, useRef, useState } from "react";
import withAuthentication from "../../components/withAuthentication";

function CalibrationTextureTestPage() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [canvasSize, setCanvasSize] = useState<number>(512);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }

    const context = canvas.getContext("2d");
    if (!context) {
      return;
    }

    context.clearRect(0, 0, canvasSize, canvasSize);
    renderCalibrationTexture(context, canvasSize);
  }, [canvasSize]);

  return (
    <>
      <div>
        <input
          type="number"
          step={10}
          min={10}
          value={canvasSize}
          onChange={(event) => setCanvasSize(event.target.valueAsNumber)}
        />
      </div>
      <canvas ref={canvasRef} width={canvasSize} height={canvasSize} />
    </>
  );
}

export const Route = createFileRoute("/debug/calibration-texture-test")({
  component: withAuthentication(CalibrationTextureTestPage, { superAdmin: true }),
});
